import { createSlice } from '@reduxjs/toolkit';
import { removeHifand } from 'src/utils/constants';

const initialState = {
    data: null,
    error: null,
    bookingStatus: []
}

export const bookingRulesSlice = createSlice({
    name: 'bookingRulesSlice',
    initialState,
    reducers: {
        bookingRuleSetSuccess: (state, action) => {
            state.data = action?.payload ?? {};
            state.error = null;
        },
        bookingRuleSetFailure: (state, action) => {
            state.data = null;
            state.error = action?.payload ?? "Something went wrong";
        },
        setBookingStatus: (state, action) => {
            let arr = action?.payload?.map((i) => ({
                key: removeHifand(i),
                value: i
            }));
            state.bookingStatus = arr;
        }
    },
});

export const {
    bookingRuleSetSuccess,
    bookingRuleSetFailure,
    setBookingStatus
} = bookingRulesSlice.actions;

export default bookingRulesSlice.reducer;